import {
  GET_FILE_REQUIREMENT,
  GET_FILE_REQUIREMENT_SUCCESS,
  GET_FILE_REQUIREMENT_FAIL,
  GET_LIST_AREA,
  GET_LIST_AREA_SUCCESS,
  GET_LIST_AREA_FAIL,
  GET_LIST_FILE_TYPE,
  GET_LIST_FILE_TYPE_SUCCESS,
  GET_LIST_FILE_TYPE_FAIL,
  SAVE_FILE,
  SAVE_FILE_SUCCESS,
  SAVE_FILE_FAIL,
  EDIT_FILE,
  EDIT_FILE_FAIL,
  EDIT_FILE_SUCCESS,
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAIL,
  CLEAN_DATA_FILE,
} from "./actionTypes"

const INIT_STATE = {
  fileList: [],
  types: [],
  error: "",
  areaList: [],
  fileTypeList: [],
  loading: true,
  loadingSave: false,
  response: null,
  responseDelete: null,
}

const fileRequirement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FILE_REQUIREMENT:
      return {
        ...state,
        fileList: [],
        loading: true,
        response: null,
      }
    case GET_FILE_REQUIREMENT_SUCCESS:
      return {
        ...state,
        fileList: action.payload.data,
        loading: false,
      }

    case GET_FILE_REQUIREMENT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
      }
    case GET_LIST_AREA:
      return {
        ...state,
        areaList: [],
      }
    case GET_LIST_AREA_SUCCESS:
      return {
        ...state,
        areaList: action.payload.data,
      }
    case GET_LIST_AREA_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_LIST_FILE_TYPE:
      return {
        ...state,
        fileTypeList: [],
      }
    case GET_LIST_FILE_TYPE_SUCCESS:
      return {
        ...state,
        fileTypeList: action.payload.data,
      }
    case GET_LIST_FILE_TYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case SAVE_FILE:
      return {
        ...state,
        loading: true,
        loadingSave: true,
        response: null,
      }
    case SAVE_FILE_SUCCESS:
      return {
        ...state,
        loadingSave: false,
        loading: false,
        error: "",
        response: action.payload.data,
      }
    case SAVE_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }
    case EDIT_FILE:
      return {
        ...state,
        loadingSave: true,
        error: "",
        response: null,
        loading: true,
      }
    case EDIT_FILE_SUCCESS:
      return {
        ...state,
        loadingSave: false,
        loading: false,
        error: "",
        response: action.payload.data,
      }
    case EDIT_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }
    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        response: action.payload.data,
        loading: false,
        responseDelete: action.payload.data,
      }
    case DELETE_FILE:
      return {
        ...state,
        response: null,
        loading: true,
        responseDelete: null,
      }
    case DELETE_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
        loadingSave: false,
      }
    case CLEAN_DATA_FILE:
      return {
        ...state,
        error: null,
        loading: false,
        response: null,
        loadingSave: false,
        responseDelete: null,
      }
    default:
      return state
  }
}

export default fileRequirement
